/** SessionStorage keys for the player login presence prompt. */

export const PRESENCE_PROMPT_LOGIN_KEY = "smarttt.presencePrompt.justLoggedIn";
export const PRESENCE_PROMPT_LATER_KEY = "smarttt.presencePrompt.later";

export function markPresencePromptAfterLogin() {
  try {
    sessionStorage.setItem(PRESENCE_PROMPT_LOGIN_KEY, "1");
    // New login: ask again even if the player chose "later" last time.
    sessionStorage.removeItem(PRESENCE_PROMPT_LATER_KEY);
  } catch {
    /* ignore */
  }
}

export function consumePresencePromptLoginFlag() {
  try {
    const v = sessionStorage.getItem(PRESENCE_PROMPT_LOGIN_KEY);
    if (v) sessionStorage.removeItem(PRESENCE_PROMPT_LOGIN_KEY);
    return v === "1";
  } catch {
    return false;
  }
}

export function peekPresencePromptLoginFlag() {
  try {
    return sessionStorage.getItem(PRESENCE_PROMPT_LOGIN_KEY) === "1";
  } catch {
    return false;
  }
}

function laterMap() {
  try {
    const raw = sessionStorage.getItem(PRESENCE_PROMPT_LATER_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function isPresencePromptDeferred(tsId) {
  if (!tsId) return false;
  return Boolean(laterMap()[String(tsId)]);
}

export function deferPresencePrompt(tsId) {
  if (!tsId) return;
  const next = { ...laterMap(), [String(tsId)]: Date.now() };
  try {
    sessionStorage.setItem(PRESENCE_PROMPT_LATER_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}

export function clearDeferredPresencePrompt(tsId) {
  if (!tsId) return;
  const next = { ...laterMap() };
  delete next[String(tsId)];
  try {
    sessionStorage.setItem(PRESENCE_PROMPT_LATER_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}

function isPresenceAnsweredPresent(value) {
  return value === true || value === 1 || value === "1" || value === "true";
}

function isPresenceAnsweredAbsent(value) {
  return value === false || value === 0 || value === "0" || value === "false";
}

/** Unanswered presence (never recorded). true/false already decided. */
export function isPresenceUnanswered(value) {
  return !isPresenceAnsweredPresent(value) && !isPresenceAnsweredAbsent(value);
}

export function sortSessionsByStart(sessions, parseWindow) {
  return [...(sessions || [])].sort((a, b) => {
    const aw = parseWindow?.(a)?.startMs ?? 0;
    const bw = parseWindow?.(b)?.startMs ?? 0;
    return aw - bw;
  });
}

export function shouldOfferPresencePrompt({
  presence,
  tsId,
  justLoggedIn,
} = {}) {
  if (justLoggedIn !== true) return false;
  if (!isPresenceUnanswered(presence)) return false;
  if (isPresencePromptDeferred(tsId)) return false;
  return true;
}
